import React from "react";

function FormSupplierVendas({venda}) {




  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-6">💰 Produtos Vendidos</h1>

        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="px-4 py-2">Produto</th>
                <th className="px-4 py-2">Quantidade</th>
                <th className="px-4 py-2">Total de Venda(kz)</th>
                <th className="px-4 py-2">Cliente</th>
                <th className="px-4 py-2">Data</th>
              </tr>
            </thead>
            <tbody>
           {venda?.map((vendas, index) => (
                <tr key={index} className="text-center border-t">
                  <td className="px-4 py-2">{vendas?.nameProduto}</td>
                  <td className="px-4 py-2">{vendas?.quantidade}</td>
                  <td className="px-4 py-2">{(vendas?.price *vendas?.quantidade).toFixed(2)} kz</td>
                  <td className="px-4 py-2">{vendas?.cliente}</td>
                  <td className="px-4 py-2">{vendas?.data}</td>
                </tr>
              ))} 
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default FormSupplierVendas;